import { connect } from "react-redux";
import * as applicationActions from "./actions";
import { get_row_additional_data_bisnode } from "./actions";
import * as usersActions from "../users/actions";

function mapStateToProps(state) {
  return {
    applications: state.applications.reviewingApplications,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getApplications: () => {
      //dispatch(applicationActions.get_reviewing_applications());
      dispatch(applicationActions.get_applications());
    },

    changeApplicationListPage: (page) => {
      dispatch(applicationActions.change_application_on_hold_list_page(page));
    },

    changeApplicationListFilter: (keyName, event) => {
      dispatch(
        applicationActions.change_application_on_hold_list_filter(
          keyName,
          event.target.value,
        ),
      );
    },

    approveApplication: (applicationId, offerId) => {
      dispatch(applicationActions.approve_application(applicationId, offerId));
    },

    rejectApplication: (applicationId) => {
      dispatch(applicationActions.reject_application(applicationId));
    },

    setRiskBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_risk_offer(postData));
    },

    setNominalBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_nominal_offer(postData));
    },

    getRowAdditionalData: (accountId, identity, bankAccountId, Id) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
      dispatch(get_row_additional_data_bisnode(accountId, Id));
    },

    swapApplications: () => {
      dispatch(applicationActions.swap_data());
    },

    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },
  };
}

export const reviewingApplicationConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
